var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"50","cy":"50","fill":"none","stroke":"#bba88c","strokeWidth":"10","r":"35","strokeDasharray":"164.93361431346415 56.97787143782138"},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","values":"0 50 50;360 50 50","keyTimes":"0;1"})));
}

Spinner.defaultProps = {"style":{"margin":"auto","background":"none","display":"block","shapeRendering":"auto"},"width":"200px","height":"200px","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = Spinner;

Spinner.default = Spinner;
